<template>
  <custom-select
    @apply="applyFilter"
    @close="onClose"
    :placeholder="placeholder"
  >
    <template #head>
      <custom-select-tag-head
        v-if="haveSelectedOptions"
        :title="tagTitle"
        @clear="clear"
      />
    </template>

    <slot
      :add="addOption"
      :remove="removeOption"
      slot="dropdown-content"
      :options="options"
      :selected-options="tempSelectedOptions"
    />
  </custom-select>
</template>

<script>
import CustomSelect from '@kit/custom-select/custom-select.vue';
import CustomSelectTagHead from '@kit/custom-select/custom-select-tag-head.vue';

import defaultFilterMixin from '@/components/filters/default-filter-mixin';

export default {
  name: 'filter-default-multiselect',

  components: {
    CustomSelect,
    CustomSelectTagHead,
  },

  mixins: [defaultFilterMixin],

  props: {
    placeholder: {
      type: String,
      required: true,
    },
  },

  computed: {
    tagTitle() {
      if (this.value.length === 1) {
        // по value достаем label
        const firstValue = this.value[0].value;
        const option = this.options.find((o) => {
          return o.value === firstValue;
        });
        const value = option?.label || option.value;

        return `${this.placeholder}: ${value}`;
      }

      return `${this.placeholder}: ${this.value.length}`;
    },
  },

  methods: {
    onClose() {
      this.tempSelectedOptions = [...this.value];
    }
  }
}
</script>
